import { takeLatest, all, put, call } from 'redux-saga/effects';
import ThemeActions from './theme-actions';
import ThemeApi from './theme-api';

function* fetchThemesHandler({ payload: { formatType, containerRef, params } }) {
  const { themes, error } = yield call(ThemeApi.fetchThemes, formatType, containerRef, params);

  if (error) yield put(ThemeActions.fetchThemesFailure(error));
  else yield put(ThemeActions.fetchThemesSuccess(themes));
}

export default function* themeSagas() {
  yield all([takeLatest(ThemeActions.fetchThemes.getType(), fetchThemesHandler)]);
}
